import React from "react";

import Wrapper from "./Wrapper";
import List from "./List";
import ArrowUp from "../Arrows/ArrowUp";
import ArrowDown from "../Arrows/ArrowDown";
import Checkbox from "../Checkbox";

class Leaf extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.open ||
      nextProps.open ||
      this.props.selected !== nextProps.selected
    );
  }
  render() {
    const props = this.props;
    const childItems = props.childItems;
    const open = props.open;
    const selected = props.selected;
    const Arrow = open ? ArrowUp : ArrowDown;

    return (
      <Wrapper {...props}>
        {0 < childItems.length && (
          <Arrow onClick={() => props.toggleOpen(props.item)} />
        )}
        <Checkbox
          type="checkbox"
          checked={selected}
          onClick={() => props.toggleSelected(props.item)}
        >
          {props.item.name}
        </Checkbox>
        {0 < childItems.length &&
          open && (
            <List>
              {childItems.map((child, key) => (
                <Leaf
                  {...props}
                  key={key}
                  item={child}
                  open={props.isOpen(child)}
                  selected={props.isSelected(child)}
                  childItems={props.childrenSelector(child, props.items)}
                />
              ))}
            </List>
          )}
      </Wrapper>
    );
  }
}

export default Leaf;
